import { render, staticRenderFns } from "./ShelvePanel.vue?vue&type=template&id=3a3a6f63&scoped=true"
import script from "./ShelvePanel.vue?vue&type=script&lang=js"
export * from "./ShelvePanel.vue?vue&type=script&lang=js"
import style0 from "./ShelvePanel.vue?vue&type=style&index=0&id=3a3a6f63&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a3a6f63",
  null
  
)

export default component.exports